import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail, Instagram } from 'lucide-react';
import { studioInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: Mail, href: 'mailto:cultivaistudio1@gmail.com', label: 'Email' },
    { icon: Instagram, href: 'https://www.instagram.com/cultivai.studio/', label: 'Instagram' },
  ];

  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-white text-2xl font-light mb-4">{studioInfo.name}</h3>
            <p className="text-white/60 text-sm leading-relaxed">
              {studioInfo.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-sm font-normal mb-4 tracking-wide">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  title="AI creative agency home"
                  className="text-white/60 text-sm hover:text-white transition-colors duration-300"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/portfolio"
                  title="AI viral case studies"
                  className="text-white/60 text-sm hover:text-white transition-colors duration-300"
                >
                  AI viral case studies
                </Link>
              </li>
              <li>
                <Link
                  to="/ai-creatives"
                  title="AI creatives gallery"
                  className="text-white/60 text-sm hover:text-white transition-colors duration-300"
                >
                  AI creatives gallery
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  title="Book a strategy call"
                  className="text-white/60 text-sm hover:text-white transition-colors duration-300"
                >
                  Book a strategy call
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="text-white text-sm font-normal mb-4 tracking-wide">Connect</h4>
            <div className="flex gap-4">
              {socialLinks.map(({ icon: Icon, href, label }) => (
                <motion.a
                  key={label}
                  href={href}
                  aria-label={label}
                  whileHover={{ scale: 1.1, y: -2 }}
                  transition={{ duration: 0.2 }}
                  className="w-10 h-10 flex items-center justify-center border border-white/20 hover:border-white/40 rounded-sm text-white/60 hover:text-white transition-colors duration-300"
                >
                  <Icon size={18} />
                </motion.a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {currentYear} {studioInfo.name}. All rights reserved.
          </p>
          <div className="flex gap-6">
            {/*
            <a href="#" className="text-white/40 text-sm hover:text-white/60 transition-colors duration-300">
              Privacy Policy
            </a>
            <a href="#" className="text-white/40 text-sm hover:text-white/60 transition-colors duration-300">
              Terms of Service
            </a>
            */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;